import "../styles/EducationPage.css";
import { useEffect, useState } from "react";
import AOS from "aos";
import EducationCard from "../components/EducationCard";
import axios from "axios";
import Loader from "../components/Loader";

interface Universities {
  id: number;
  size: string;
  university: string;
  degree: string;
  dates: string;
  link: string;
  studies: string[];
}

const EducationPage = () => {
  const [universities, setUniversities] = useState<Universities[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [backend] = useState<string>(
    "https://personal-portfolio-backend-waf6.vercel.app"
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 500, // Animation duration in milliseconds
      offset: 200, // Trigger animation when 200px from the top
      easing: "ease-in-out", // Animation easing function
      once: true, // Animation runs only once
      mirror: true, // Animation plays again when scrolling back up
    });
    const fetchUniversities = async (
      retryCount = 0,
      retryLimit = 60,
      retryDelay = 2000
    ) => {
      try {
        const response = await axios.get(backend + "/content/education.json");
        if (response.data) {
          setUniversities(response.data);
          setLoading(false); // Stop retrying after success
        } else {
          setError("No education found.");
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching education:", error);
        if (retryCount < retryLimit) {
          setTimeout(() => fetchUniversities(retryCount + 1), retryDelay);
        } else {
          setError("Failed to fetch education. Please try again later...");
          setLoading(false);
        }
      }
    };

    fetchUniversities();
  }, [backend]);

  return (
    <div className="educationPage">
      <div className="title" data-aos="fade-up">
        Education
      </div>
      {error && <p className="message">{error}</p>}

      {loading ? (
        <div className="universitiesLoader" data-aos="fade-up">
          <Loader />
        </div>
      ) : (
        <div className="educationCardsContainer" data-aos="fade-up">
          {universities.map((uni, index) => (
            <EducationCard
              key={uni.id}
              id={uni.id}
              eduSize={uni.size}
              eduUniversity={uni.university}
              eduDegree={uni.degree}
              eduDates={uni.dates}
              eduLink={uni.link}
              eduStudies={uni.studies}
              position={index % 2 === 0 ? "left" : "right"} // even = left, odd = right
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default EducationPage;
